<template>
  <div>
    <div
      class="dropdown dropdown-notification"
      v-show="
        $store.state.app.activeGroup.id == 9157 ? newlocalMailCount > 0 : true
      "
    >
      <a
        @click="init()"
        role="button"
        class="dropdown-link btn btn-icon rounded-circle wd-60 d-flex align-items-center justify-content-center"
        data-toggle="dropdown"
      >
        <img
          :src="
            `${myResBaseUrl}v4-assets/svgicon/interface/outline/notification 01.svg`
          "
          class="wd-32"
        />
        <span v-show="newlocalMailCount > 0">
          {{ newlocalMailCount }}
        </span>
      </a>
      <div class="dropdown-menu dropdown-menu-right mg-b-sm">
        <div
          class="dropdown-header bd-b-0-f mg-b-0-f tx-bold-f tx-20-f"
          style="    text-transform: none;"
        >
          Мэдэгдэл
        </div>
        <template v-if="mails.length == 0">
          <div class="card">
            <div class="card-body">Хоосон байна.</div>
          </div>
        </template>
        <div
          v-else
          class="pd-b-5 overflow-auto"
          style="max-height: 60vh; overflot-y:auto"
        >
          <a
            @click="loadMail(m)"
            role="button"
            :class="
              `rounded mg-b-3-f dropdown-item ${
                !m.isSeen ? 'bg-light' : 'bg-gray-100'
              }`
            "
            :key="i + '_mlnotifs'"
            v-for="(m, i) in mails"
          >
            <div class="media">
              <div class="avatar">
                <img
                  :src="m.fromUser.avator"
                  :alt="m.fromUser.fullName"
                  class="rounded"
                />
              </div>
              <div class="media-body mg-l-15">
                <strong class="tx-12">{{ m.fromUser.fullName }} </strong>
                <b class="tx-12 text-ellipsis tx-semibold">{{ m.subject }}</b>
                <b
                  v-if="
                    ($store.state.app.activeGroup.id == 9241 ||
                      $store.state.app.activeGroup.id == 9249) &&
                      m.flag != 22000
                  "
                  class="tx-12 tx-normal"
                  >Та хичээлээ орж үзэж дуусгана уу.</b
                >
                <p class="tx-10 text-muted">
                  {{ m.sentDate | moment("from") }}
                </p>
                <!-- {{ m.flag }} {{ m.sentDate }} {{ m.id }} -->
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showModal"
      :title="mailCur.subject"
      scrollable
      no-fade
      centered
      hide-footer
      hide-header
      shadow
      backdrop
      size="lg"
      body-class="pd-0"
    >
      <div class="modal-header">
        <a
          @click="showModal = false"
          role="button"
          class="pos-absolute t-15 r-15"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true" style="font-size: 28px">×</span>
        </a>
        <div class="media align-items-center">
          <span class="tx-color-03 d-none d-sm-block">
            <feather type="mail" class="wd-40-f ht-40-f"></feather>
          </span>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-16 mg-b-2">{{ mailCur.subject }}</h4>
          </div>
        </div>
      </div>

      <div class="tx-14 tx-md-16 tx-color-02 pd-20">
        <div v-html="mailCur.body"></div>
      </div>
      <div class="pd-20">
        <div class="divider-text">Хавсралт</div>
        <div class="row row-xs" v-if="mailCur.attachments.length > 0">
          <div
            :key="i"
            class="col-lg-3 col-md-4 col-sm-6"
            role="button"
            @click="showAttachment(a)"
            v-for="(a, i) in mailCur.attachments"
          >
            <div class="card card-file">
              <div class="card-file-thumb">
                <img :src="getthumb(a)" class="wd-60p" />
              </div>
              <div class="card-body">
                <h6>
                  <a :title="a.nm" class="link-02">{{ a.nm }}</a>
                </h6>
                <div class="d-flex">
                  <span>{{
                    a.size > 1024
                      ? (a.size / 1024 / 1024).toFixed(2) + "MB"
                      : (a.size / 1024).toFixed(2) + "KB"
                  }}</span>
                  <span class="mg-l-auto"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="fileDialog.modal" hide-footer size="lg" scrollable>
      <file-dialog
        :show="fileDialog.show"
        :id.sync="fileDialog.id"
        @on-hide="
          fileDialog.show = false;
          fileDialog.modal = false;
        "
        :force="true"
      />
    </b-modal>
    <!-- <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      swd="85vw"
      @on-hide="fileDialog.show=false;"
    /> -->
  </div>
</template>
<script>
import { request } from "@/api/all";
const moment = require("moment");
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    fileDialog: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      searchModel: {
        page: 0,
        skip: 0,
        size: 5,
        folderId: 0,
        fromUserTaskId: [],
        labelIds: [],
        sentDateStart: null,
        sentDateEnd: null,
        subject: "",

        firstName: "",
        title: "",
        startDate: "",
        endDate: "",
      },

      loading: {
        folder: false,
        list: false,
        detail: false,
      },

      folders: [],
      folderCur: 0,
      folderCurCode: "",
      folderCurTitle: "",
      mailsObj: {
        allCount: 0,
        count: 0,
      },
      mails: [],
      mailCur: {
        id: 0,
        attachments: [],
      },
      showModal: false,
      fileDialog: {
        show: false,
        id: 0,
        modal: false,
      },
      newlocalMailCount: 0,
      myResBaseUrl: "https://res.gosmart.mn/",
    };
  },
  mounted() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }

    request({
      api: { method: "get", url: "localmail/notSeenCount" },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        this.newlocalMailCount = res.data.count;
      }
    });

    this.$store.state.signalr.osrCon.on("onLocalmailRecieved", (id) => {
      //console.log(id);

      this.newlocalMailCount++;
      this.playSound(id);
      this.notifyMe();
      if (!this.$store.state.app.windowState) {
        //console.log(this.$store.state.app.windowState);
        document.title = "(Шинэ дотоод шуудан!) Динамик платформ";
        //this.playSound();
      }
    });

    this.$store.state.signalr.osrCon.on("onLocalmailRead", (id) => {
      //console.log(id);
      //id++;
      this.newlocalMailCount--;
    });
  },
  methods: {
    showAttachmentDrawer(p) {
      //console.log(p);
      //this.attachDrawerParams.fileId=p.defaultAttachmentId;
      this.fileDialog.id = p.id;
      this.fileDialog.show = true;
      this.fileDialog.modal = true;
    },
    showAttachment(a) {
      //console.log(a);
      //beforeLoadAttachment
      if (a.gId == this.$store.state.user.userInfo.groupId) {
        this.showAttachmentDrawer(a);
      } else {
        window.open(a.link, "_blank");
      }
    },
    getthumb(v) {
      let rv = "";
      if (
        v.ext == "jpg" ||
        v.ext == "jpeg" ||
        v.ext == "png" ||
        v.ext == "gif"
      ) {
        rv = v.link + "?w=220&h=140&mode=crop";
      } else {
        rv = this.myResBaseUrl + "media/mime/" + v.ext + ".png";
      }
      return rv;
    },
    init() {
      //this.loading.folder = true;
      request({
        api: { method: "GET", url: "LocalMail/Folders" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.folders = res.data.folders;
          let fia = res.data.folders.filter((x) => x.code == "inbox");
          if (fia.length > 0) {
            this.loadList(fia[0]);
          }
          //this.loading.folder = false;
          //this.getWindowHeight();
        }
      });
    },
    loadList(f) {
      let self = this;
      this.loading.list = true;

      if (this.folderCurCode == "sent" || this.folderCurCode == "draft") {
        this.searchModel.firstName = "";
      }

      this.folderCur = f.id;
      this.folderCurCode = f.code;
      this.folderCurTitle = f.title;

      this.mails = [];

      this.searchModel.folderId = f.id;

      if (!f.paged) {
        this.searchModel.skip = 0;
        this.searchModel.page = 0;
      }

      request({
        api: { method: "POST", url: "LocalMail/List" },
        data: this.searchModel,
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.loading.list = false;
          this.mailCur.id = false;
          this.mailsObj.allCount = res.data.allCount;
          this.mailsObj.count = res.data.count;
          this.mails = res.data.list.map((e) =>
            Object.assign(e, {
              groupDate: self.getDateGroupName(e.sentDate),
            })
          );
        }
      });
    },
    loadMail(m) {
      request({
        api: { method: "get", url: "LocalMail/Detail" },
        params: { id: m.id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          if (res.data.mail.flag == 11506 || res.data.mail.flag == 22000) {
            //alert(res.data.mail.body);
            this.$router.push(res.data.mail.body);
          } else {
            this.mailCur = res.data.mail;
            if (this.mails.filter((x) => x.id == res.data.mail.id).length > 0) {
              this.mails.filter(
                (x) => x.id == res.data.mail.id
              )[0].isSeen = true;
            }
            this.showModal = true;
          }
        }
      });
    },
    getDateGroupName(d) {
      let rv = "";
      if (moment(d).isSame(new Date(), "day")) {
        rv = "Өнөөдөр";
      } else if (moment(d).isSame(moment().subtract(1, "day"), "day")) {
        rv = "Өчигдөр " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(moment().subtract(2, "day"), "day")) {
        rv = "Уржигдар " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(new Date(), "week")) {
        rv = "Энэ долоо хоногт";
      } else if (moment(d).isSame(moment().subtract(1, "week"), "week")) {
        rv = "Өнгөрсөн долоо хоногт";
      } else if (moment(d).isSame(new Date(), "month")) {
        rv = "Энэ сард";
      } else if (moment(d).isSame(moment().subtract(1, "month"), "month")) {
        rv = "Өнгөрсөн сард";
      } else if (moment(d).isSame(new Date(), "year")) {
        rv = moment(d).format("MMMM") + "д";
        //rv= 'Энэ жилд';
      } else if (moment(d).isSame(moment().subtract(1, "year"), "year")) {
        rv = "Өнгөрсөн жилд";
      } else {
        rv = moment(d).format("YYYY") + " онд";
        //rv='Бусад';
      }
      return rv;
    },
    playSound() {
      var audio = new Audio(resBaseUrl + "media/sound/notif.mp3");
      audio.play();
    },
    notifyMe() {
      if (!("Notification" in window)) {
        //console.log("This browser does not support desktop notification");
      } else if (Notification.permission === "granted") {
        var notification = new Notification("Динамик платформ", {
          icon: resBaseUrl + "media/icon.png",
          body: "Танд шинэ дотоод шуудан ирлээ!",
        });
        notification.onclick = function() {
          let url = window.location.protocol + "//" + window.location.host;
          window.open(url);
        };
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function(permission) {
          if (permission === "granted") {
            var notification = new Notification("Динамик платформ", {
              icon: resBaseUrl + "media/icon.png",
              body: "Танд шинэ дотоод шуудан ирлээ!",
            });
            notification.onclick = function() {
              let url = window.location.protocol + "//" + window.location.host;
              window.open(url);
            };
          }
        });
      } else {
        //console.log("notifperm", Notification.permission);
      }
    },
  },
};
</script>
